module.exports = __webpack_public_path__ + "static/img/send.81ac61c2.svg";